import { render, staticRenderFns } from "./PropertyFormSubscriptions.vue?vue&type=template&id=0397c8c2&scoped=true&"
import script from "./PropertyFormSubscriptions.vue?vue&type=script&lang=js&"
export * from "./PropertyFormSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFormSubscriptions.vue?vue&type=style&index=0&id=0397c8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397c8c2",
  null
  
)

export default component.exports